export const localStorageKeys = {
  localNotifications: 'gp_local_notifications',
  contactLensImageType: 'contactLensImageType',
  contactLensImageTypeSwitcherHintDismissed: 'contactLensImageTypeSwitcherHintDismissed',
  recentlyViewed: 'checked_productclass',
  apparelAddToCartRecentSizePathnamesByBrand: 'apparel_add_to_cart_recent_size_pathnames_by_brand',
  promotionContext: 'gp_promotion_context',
} as const
